import { fetchRequest } from 'src/hooks/useAPIRequest'
import { API_ENDPOINTS } from 'src/routes/routes'

import { LoggedInResponse } from '../../types'

interface Params {
    code: string
    token: string
}

const loginMFAUser = async ({ code, token }: Params) => {
    return await fetchRequest<LoggedInResponse>(`${API_ENDPOINTS.VALIDATE_MFA}?code=${code}`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
    })
}

export default loginMFAUser
